import gql from "graphql-tag";

export const FETCH_ALL_FIAT_CURRENCIES = gql`
  query FetchAllFiatCurrencies {
    data: fetchAllFiatCurrencies {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const FETCH_ALL_CURRENCIES = gql`
  query FetchAllCurrencies {
    data: fetchAllCurrencies {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const UPDATE_ACCOUNT_CURRENCY = gql`
  mutation UpdateAccountCurrency($currencyId: String!) {
    data: updateAccountCurrency(currencyId: $currencyId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const FETCH_DISTRIBUTOR_DEPOSIT_CURRENCIES = gql`
  query FetchDistributorDepositCurrencies {
    data: fetchDistributorDepositCurrencies {
      alert {
        type
        message
      }
      payload
    }
  }
`;
